import React from "react";
import styled from "styled-components";
import { Placeholder } from "../../../../styles/Shimmer";

const GoSafeSafetyUpdatesLoaderUI = () => {
  return (
    <SafetyLoader>
      <SafetyLoaderHeader>
        <Placeholder ldrWidth="7.2rem" ldrHeight="3.2rem" margin="0 1rem 0 0" />
        <div>
          <Placeholder
            display="flex"
            ldrWidth="188px"
            ldrHeight="1.5rem"
            margin="0 0 0.2rem 0"
          />
          <Placeholder
            display="flex"
            ldrWidth="302px"
            ldrHeight="1.5rem"
            margin="0 0 0.3rem 0"
          />
        </div>
      </SafetyLoaderHeader>
      <div>
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
        <Placeholder
          ldrWidth="8.5rem"
          ldrHeight="11.2rem"
          margin="0 1rem 0 0"
        />
      </div>
    </SafetyLoader>
  );
};

const SafetyLoader = styled.div`
  border-radius: 1.2rem;
  background-color: #ffffff;
  padding: 1rem;
  margin-bottom: 2rem;
`;
const SafetyLoaderHeader = styled.div`
  display: flex;
  margin-bottom: 1.7rem;
`;

export default GoSafeSafetyUpdatesLoaderUI;
